import axios from "axios";
import { IP } from "./config";

// 查询店铺
export async function selectStore(data) {
  var resp = await axios.post(`${IP}/store/selectStore`, {
    ...data,
  });
  return resp.data;
}
// 新增店铺
export async function addStore(form) {
  var resp = await axios.post(`${IP}/store/addStore`, {
    ...form,
  });
  return resp.data;
}
// 修改店铺
export async function updateStore(form) {
  var resp = await axios.post(`${IP}/store/updateStore`, {
    ...form,
  });
  return resp.data;
}
// 删除店铺
export async function deleteStore(id) {
  var resp = await axios.post(`${IP}/store/deleteStore`, {
    id,
  });
  return resp.data;
}

/* 查询门店交易额 */
export async function slectStoreData(data) {
  var resp = await axios.post(`${IP}/store/slectStoreData`, {
    ...data,
  });
  return resp.data;
}

/* 查询门店交易额 */
export async function slectStoreMoneyData(data) {
  var resp = await axios.post(`${IP}/store/slectStoreMoneyData`, {
    ...data,
  });
  return resp.data;
}
